import EditServicePageComponent from "./components/EditServicePageComponent";

import { useSelector } from "react-redux";
import axios from 'axios'
import { useDispatch } from "react-redux";
import { saveAttributeToCatDoc } from "../../redux/actions/categoryActions";
import { uploadImagesApiRequest, uploadImagesCloudinaryApiRequest } from "./utils/utils";

const fetchService = async (serviceId) => {
    const { data } = await axios.get(`/api/services/get-one/${serviceId}`);
    return data;
}

const updateServiceApiRequest = async (serviceId, formInputs) => {
    const { data } = await axios.put(`/api/services/admin/${serviceId}`, { ...formInputs });
    return data;
}

const AdminEditServicePage = () => {

  const { categories } = useSelector((state) => state.getCategories);

  const reduxDispatch = useDispatch();

  const imageDeleteHandler = async (imagePath, serviceId) => {
      let encoded = encodeURIComponent(imagePath)
      if (process.env.NODE_ENV !== "serviceion") {
          // to do: change to !==
        await axios.delete(`/api/services/admin/image/${encoded}/${serviceId}`);
      } else {
        await axios.delete(`/api/services/admin/image/${encoded}/${serviceId}`);
      }
  }

  return <EditServicePageComponent 
            categories={categories} 
            fetchService={fetchService} 
            updateServiceApiRequest={updateServiceApiRequest} 
            reduxDispatch={reduxDispatch} 
            saveAttributeToCatDoc={saveAttributeToCatDoc} 
            imageDeleteHandler={imageDeleteHandler} 
            uploadImagesApiRequest={uploadImagesApiRequest} 
            uploadImagesCloudinaryApiRequest={uploadImagesCloudinaryApiRequest}  />;
};

export default AdminEditServicePage;
